import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.js'
import '@/assets/css/common.css'
import i18n from './lang' // 引入

Vue.config.productionTip = false

new Vue({
  i18n, // 挂载
  router,
  store,
  render: h => h(App)
}).$mount('#app')
